import styled, { keyframes } from "styled-components";

import { BODY, SEMI_BOLD, REGULAR } from "@/constants/fonts";
import {
  MINESHAFT_GREY,
  SUCCESS_GREEN,
  SUCCESS_GREEN_LIGHT,
  WARNING_YELLOW,
  WARNING_YELLOW_LIGHT,
  DANGER_RED,
  DANGER_SECONDARY,
  INFO_BLUE,
  INFO_BLUE_LIGHT,
} from "@/constants/colors";

import { ALERT_LEVELS } from "./constants";

const colorPair = (primary, secondary) => ({
  primary,
  secondary,
});

const ALERT_COLORS = {
  [ALERT_LEVELS.SUCCESS]: colorPair(SUCCESS_GREEN, SUCCESS_GREEN_LIGHT),
  [ALERT_LEVELS.INFO]: colorPair(INFO_BLUE, INFO_BLUE_LIGHT),
  [ALERT_LEVELS.WARNING]: colorPair(WARNING_YELLOW, WARNING_YELLOW_LIGHT),
  [ALERT_LEVELS.ERROR]: colorPair(DANGER_RED, DANGER_SECONDARY),
};

const slide = keyframes`
  from {
    margin-top: -98px;
  }
  to {
    margin-top: 16px
  }
`;

export const AlertContentGrid = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  display: grid;
  grid-template-columns: 16px 32px 16px auto 8px 20px 8px;
  /* The title and body rows were pinned at 16px each. A body long enough to
     wrap overflowed its area and, with align-items: center, spilled upward
     into the title, so the two ran together. minmax keeps the original height
     for short content and lets a wrapped line push the row instead
     (WCHK-3048 review). */
  grid-template-rows: 4px 12px 8px minmax(16px, auto) minmax(16px, auto) 8px 16px;
  grid-template-areas:
    ". ........ . ..... . ..... ."
    ". ........ . ..... . xIcon ."
    ". ........ . title . xIcon ."
    ". mainIcon . title . ..... ."
    ". mainIcon . body  . ..... ."
    ". ........ . body  . ..... ."
    ". ........ . ..... . ..... .";
  border-radius: 3px;
  align-items: center;
  border: 1px solid ${({ alertLevel }) => ALERT_COLORS[alertLevel].primary};
  background-color: ${({ alertLevel }) => ALERT_COLORS[alertLevel].secondary};
  animation: ${slide} 0.2s ease-out;
`;

export const TitleWrapper = styled.div`
  grid-area: title;
  color: ${MINESHAFT_GREY};
  font-weight: ${SEMI_BOLD};
  font-size: 20;
  font-family: ${BODY};
`;

export const BodyWrapper = styled.div`
  grid-area: body;
  color: ${MINESHAFT_GREY};
  font-weight: ${REGULAR};
  font-size: 16px;
  font-family: ${BODY};
`;

export const IconSection = styled.div`
  grid-area: mainIcon;
  justify-self: center;
`;

export const IconWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const XIconWrapper = styled.button`
  grid-area: xIcon;
  cursor: pointer;
  /* A real button so the control is reachable and named for keyboard and
     screen-reader users (WCAG 2.2 AA, 2.1.1 and 4.1.2). The reset keeps the
     rendered alert unchanged. */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  &:focus-visible,
  &:focus {
    outline: 2px solid ${MINESHAFT_GREY};
    outline-offset: 2px;
  }
`;
